import React from 'react';
import { PageLayout } from '@voilajsx/uikit/page';
import { Header, Footer, SEO } from '../../../shared/components';

const APP_NAME = import.meta.env.VITE_APP_NAME === 'plotmagic' ? 'PlotMagic' : 'RRD Planners';
const LEGAL_NAME = 'Kuthati Sai Ram';
const EMAIL = 'rrdplotmagic@gmail.com';
const PHONE = '+91 9573766436';

const CancellationPage: React.FC = () => {
  return (
    <PageLayout size="full">
      <SEO title={`Cancellation Policy - ${APP_NAME}`} description="Our cancellation policy" />
      <Header />
      <PageLayout.Content>
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="space-y-8">
            <div className="text-center space-y-4">
              <h1 className="text-4xl font-bold text-foreground">Cancellation Policy</h1>
              <p className="text-muted-foreground">Last updated: April 2026</p>
            </div>

            <div className="prose prose-gray dark:prose-invert max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">1. Credit Pack Purchases</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Credit pack purchases can be cancelled and refunded if the request is made within 7 days of purchase and none of the purchased credits have been used. Once credits are consumed for PDF downloads, the corresponding amount cannot be cancelled or refunded.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">2. Cancellation Before Payment</h2>
                <p className="text-muted-foreground leading-relaxed">
                  You may cancel a credit pack order at any time before completing the payment on the checkout page. No charges will be applied if payment is not completed.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">3. Account Cancellation</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  You may request to cancel/delete your account at any time by contacting us. Upon account cancellation:
                </p>
                <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                  <li>Your saved designs will be permanently deleted</li>
                  <li>Any remaining unused credits will be forfeited unless a refund is requested within the eligible window</li>
                  <li>Your personal information will be deleted in accordance with our Privacy Policy</li>
                  <li>Transaction records may be retained as required by tax/accounting laws</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">4. How to Cancel</h2>
                <p className="text-muted-foreground leading-relaxed">
                  To cancel a purchase or your account, contact us at:<br /><br />
                  Email: <a href={`mailto:${EMAIL}`} className="text-primary hover:underline">{EMAIL}</a><br />
                  Phone: <a href={`tel:${PHONE}`} className="text-primary hover:underline">{PHONE}</a>
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">5. Refund on Cancellation</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Eligible cancellation refunds are processed within 5-7 working days to the original payment method. Please refer to our <a href="/refund" className="text-primary hover:underline">Refund Policy</a> for complete details.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">6. Contact</h2>
                <p className="text-muted-foreground leading-relaxed">
                  <strong>{LEGAL_NAME}</strong><br />
                  Email: <a href={`mailto:${EMAIL}`} className="text-primary hover:underline">{EMAIL}</a><br />
                  Phone: <a href={`tel:${PHONE}`} className="text-primary hover:underline">{PHONE}</a>
                </p>
              </section>
            </div>

            <div className="text-center pt-8 border-t border-border">
              <a href="/" className="inline-flex items-center text-primary hover:underline font-medium">← Back to Home</a>
            </div>
          </div>
        </div>
      </PageLayout.Content>
      <Footer />
    </PageLayout>
  );
};

export default CancellationPage;
